<template>
  <div class="box">
    <v-card class="mx-auto">
      <v-sheet
        color="grey lighten-3"
        height="50"
        style="justify-content: center; display: flex; align-items: center"
        ><p class="title mb-0">Blog</p></v-sheet
      >

      <v-card-text>
        <p v-html="textBlog"></p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ["textBlog"],
};
</script>